import React from 'react';
import { Close } from 'styled-icons/material/Close';

import { Flex } from '../Flex';
import { Text } from '../Text';
import { StyledButton } from '../StyledButton';
import { StyledOuterSelectedItem } from './Combobox.styled';

export const DefaultMultiValuesWrapper = ({ children }) => (
  <Flex flexWrap="wrap" mt={14}>
    {children}
  </Flex>
);

export const OuterSelectedItem = React.forwardRef(({ children, onRemove, ...rest }, ref) => (
  <StyledOuterSelectedItem ref={ref} {...rest}>
    <Text as="span" mr={10} textStyle="ellipsis">
      {children}
    </Text>
    <StyledButton title="remove" onClick={onRemove} minWidth="14px" className="close-icon">
      <Close size={14} />
    </StyledButton>
  </StyledOuterSelectedItem>
));
